export const processHeaders = [
    { key: "pro_id", label: "id" },
    { key: "pro_name", label: "process_area" },
    { key: "pro_start_date", label: "pro_start_date" },
    { key: "pro_end_date", label: "pro_end_date" },
    { key: "pro_status", label: "status" },
    { key: "pro_budget", label: "budget" },
  ];